export default {
	matching: 'مطابقة'
}